import userMappingIndex from "./user_mapping/Index.vue";
import userMappingRoute from "./user_mapping/routes";
import warehouseRoute from "./warehouse/routes";
import customerRoute from "./customer/routes";
import systemCodeRoute from "./SystemCode/routes";
import employeeRoute from "./employee/routes";
import costOvertimeRoute from "./cost_overtime/routes";
import logicOvertimeRoute from "./logic_overtime/routes";
import overtimeRoute from "./overtime/routes";
import whActivityRoute from "./wh_activity/routes";
import WhMonitoringIndex from "./Index.vue";
import PageDashboard from "./PageDashboard.vue";

import DocumentPhotoIndex from "./document_photo/Index.vue";
import DocumentPhotoRoute from "./document_photo/routes";

export default [
  {
    path: "",
    meta: {
      title: "WH-Monitoring Dashboard",
    },
    component: PageDashboard,
  },
  {
    path: "user-mapping",
    meta: {
      title: "WH-Monitoring",
    },
    children: userMappingRoute,
    component: userMappingIndex,
  },
  {
    path: "warehouse",
    meta: {
      title: "WH-Monitoring",
    },
    children: warehouseRoute,
    component: WhMonitoringIndex,
  },
  {
    path: "system-code",
    meta: {
      title: "WH-Monitoring",
    },
    children: systemCodeRoute,
    component: WhMonitoringIndex,
  },
  {
    path: "customer",
    meta: {
      title: "WH-Monitoring",
    },
    children: customerRoute,
    component: WhMonitoringIndex,
  },
  {
    path: "employee",
    meta: {
      title: "WH-Monitoring",
    },
    children: employeeRoute,
    component: WhMonitoringIndex,
  },
  {
    path: "cost-overtime",
    meta: {
      title: "WH-Monitoring",
    },
    children: costOvertimeRoute,
    component: WhMonitoringIndex,
  },
  {
    path: "logic-overtime",
    meta: {
      title: "WH-Monitoring",
    },
    children: logicOvertimeRoute,
    component: WhMonitoringIndex,
  },
  {
    path: "overtime",
    meta: {
      title: "WH-Monitoring",
    },
    children: overtimeRoute,
    component: WhMonitoringIndex,
  },
  {
    path: "wh-activity",
    meta: {
      title: "WH-Monitoring",
    },
    children: whActivityRoute,
    component: WhMonitoringIndex,
  },
  {
    path: "document-photo",
    meta: {
      title: "WH-Monitoring",
    },
    children: DocumentPhotoRoute,
    component: DocumentPhotoIndex,
  },
];
